module.exports = __webpack_public_path__ + "img/money.ea2b936f.svg";